{
  "list": {
    "title": "Label Designer",
    "subtitle": "Design label layouts once, then print them for any matching material.",
    "newTemplate": "New Template",
    "submitForApproval": "Submit for Approval",
    "delete": "Delete template",
    "approve": "Approve",
    "reject": "Reject",
    "noDescription": "No description provided.",
    "dimensions": "{{width}} × {{height}} mm",
    "objectCount": "{{count}} object(s)",
    "assignedMaterial": "Material: {{name}}",
    "updatedBy": "Updated {{date}} by {{name}}"
  },
  "toolbox": {
    "components": "Components",
    "sections": {
      "general": "General",
      "barcodes": "Barcodes",
      "shapesMedia": "Shapes & Media",
      "data": "Data"
    },
    "items": {
      "text": "Text",
      "dynamic": "Bound Field",
      "dateTime": "Date/Time",
      "serialNumber": "Serial No.",
      "barcode": "Barcode",
      "qr": "QR Code",
      "logo": "Logo/Image",
      "line": "Line",
      "rectangle": "Rectangle",
      "ellipse": "Circle",
      "table": "Field Table"
    }
  },
  "canvas": {
    "logoPlaceholder": "Drop logo here",
    "tableNoFields": "No fields selected"
  },
  "designer": {
    "templatesBreadcrumb": "Label Templates",
    "saveTemplate": "Save Template",
    "saving": "Saving...",
    "duplicate": "Duplicate",
    "delete": "Delete",
    "goToPrinting": "Go to Label Printing",
    "deleteDialog": {
      "title": "Delete Template",
      "message": "Delete \"{{name}}\"? This cannot be undone.",
      "confirm": "Delete"
    },
    "approvalBar": {
      "message": "This template is awaiting your approval before it can be used for printing.",
      "approve": "Approve",
      "reject": "Reject"
    }
  },
  "properties": {
    "templateSetup": "Template Setup",
    "templateName": "Template Name",
    "width": "Width (mm)",
    "height": "Height (mm)",
    "description": "Description",
    "selectPrompt": "Select an object on the canvas to edit its properties.",
    "assignment": {
      "title": "Assignment",
      "assignTo": "Assign To",
      "generic": "Generic (any material)",
      "material": "Specific Material",
      "packing": "Packing",
      "weightProduction": "Weigh & Label",
      "genericHelp": "This template is offered for every material on the GRN and Production Label Printing screens.",
      "scopedHelp": "This template is only offered once the selected material matches, on the GRN and Production Label Printing screens.",
      "packingHelp": "This template is only offered on the Packing Label Print screen, once approved.",
      "weightProductionHelp": "This template is only offered on the Weigh & Label screens and Item Master's weight configuration, once approved."
    },
    "properties": "Properties",
    "x": "X (mm)",
    "y": "Y (mm)",
    "objWidth": "Width (mm)",
    "objHeight": "Height (mm)",
    "bindMaterialField": "Bind Material Field",
    "fieldsScope": "Showing fields for: {{scope}}",
    "field": "Field",
    "insertField": "Insert Field",
    "setAsDataSource": "Set as Data Source",
    "autoGenerateToggle": "Auto-Generate Value",
    "autoGenerate": {
      "prefix": "Prefix",
      "suffix": "Suffix",
      "startValue": "Start Value",
      "increment": "Increment",
      "padding": "Padding",
      "previewPrefix": "First value:",
      "previewSuffix": "Each printed label gets its own never-repeating value."
    },
    "textPlaceholder": "Text",
    "tokenHelperText": "Use {{Token}} to bind a Material field, e.g. {{MaterialCode}}.",
    "fontSize": "Font Size",
    "align": "Align",
    "alignLeft": "Left",
    "alignCenter": "Center",
    "alignRight": "Right",
    "bold": "Bold",
    "symbology": "Symbology",
    "dataSource": "Data Source",
    "humanReadable": "Show human-readable text",
    "errorCorrection": "Error Correction",
    "shape": "Shape",
    "shapeRectangle": "Rectangle",
    "shapeEllipse": "Ellipse",
    "borderWidth": "Border Width",
    "borderColor": "Border Color",
    "logoImage": "Logo / Image",
    "uploadImage": "Upload Image",
    "replaceImage": "Replace Image",
    "removeImage": "Remove",
    "tableFields": "Table Fields",
    "tableFieldsPicker": "Fields",
    "rowHeight": "Row Height",
    "tableShowLabels": "Show field labels",
    "deleteObject": "Delete Object"
  }
}
